module.exports = __webpack_public_path__ + "img/triceps.65d61ea6.png";